import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useContasPagarListaFilters
 */

const getFirstDayOfMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
};

const getLastDayOfMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0);
};

type State = {
    idsCentroCusto?: number[];
    idsOrdemCompra?: number[];
    idsBanco?: number[];
    idsSubconta?: number[];
    idsFornecedor?: number[];
    idsFuncionario?: number[];
    idsFuncionarioPago?: number[];
    idsProdutoServico?: number[];
    idsPgtoMedicao?: number[];

    titulo?: string | null;
    valor?: number | null;
    nrContasPagar?: number | null;
    nrNotaFiscal?: string | null;
    nrNotaFiscalEspecial?: string | null;
    formaPagamento?: string | null;
    status?: number | null;

    dataPagarDe?: Date | null;
    dataPagarAte?: Date | null;
    dataPagoDe?: Date | null;
    dataPagoAte?: Date | null;
    dataCriacaoDe?: Date | null;
    dataCriacaoAte?: Date | null;


};

type Action = {
    setFilters: (filters: Partial<State>) => void;
    clearFilters: () => void;
};


export const useContasPagarListaFilters = create<State & Action>((set) => ({
    idsCentroCusto: [],
    idsOrdemCompra: [],
    idsBanco: [],
    idsSubconta: [],
    idsFornecedor: [],
    idsFuncionario: [],
    idsFuncionarioPago: [],
    idsProdutoServico: [],
    idsPgtoMedicao: [],

    titulo: "",
    valor: null,
    nrContasPagar: null,
    nrNotaFiscal: null,
    nrNotaFiscalEspecial: null,
    formaPagamento: null,
    status: 4,

    dataPagarDe: getFirstDayOfMonth(),
    dataPagarAte: getLastDayOfMonth(),
    dataPagoDe: null,
    dataPagoAte: null,
    dataCriacaoDe: null,
    dataCriacaoAte: null,
    setFilters: (filters) => set((state) => ({ ...state, ...filters })),
    clearFilters: () => set({ ...initialContasPagarFiltersValues }),
}));

export const initialContasPagarFiltersValues: State = {
    idsCentroCusto: [],
    idsOrdemCompra: [],
    idsBanco: [],
    idsSubconta: [],
    idsFornecedor: [],
    idsFuncionario: [],
    idsFuncionarioPago: [],
    idsProdutoServico: [],
    idsPgtoMedicao: [],

    titulo: "",
    valor: null,
    nrContasPagar: null,
    nrNotaFiscal: null,
    nrNotaFiscalEspecial: null,
    formaPagamento: null,
    status: 4,

    dataPagarDe: null,
    dataPagarAte: null,
    dataPagoDe: null,
    dataPagoAte: null,
    dataCriacaoDe: null,
    dataCriacaoAte: null,

};

